import * as React from 'react';
import {connect} from 'react-redux';
import {withTranslation} from 'react-i18next';
import * as ReportModule from 'Modules/ReportModule';
import i18next from 'i18next';
import ReactTable from "react-table";
import {Cell, injectThProps} from "HelperFunctions/Lists";

type P = {
    //
};
type S = {
    //
};
type ConnectedP = {
    reportStore: ReportModule.Types.ReportStore;
    t?: i18next.TFunction;
};

class TerminalInstallationReport extends React.Component<P & ConnectedP, S> {
    public render() {
        const {reportStore, t} = this.props;
        if (reportStore.terminalInstallationReport) {
            return (
                <>
                    <h3 className="main__title">{t('Raport instalacji terminali')}</h3>

                    <ReactTable
                        className="pure-table"
                        data={reportStore.terminalInstallationReport.installations}
                        filterable={false}
                        sortable={false}
                        columns={this.renderColumns(t)}
                        pageSize={5}
                    />
                </>
            );
        } else {
            return null;
        }
    }

    private renderColumns = (t) => [
        {
            Header: Cell.HeaderTextCell(t('deviceId')),
            accessor: 'deviceId',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('carModel')),
            accessor: 'carModel',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('address')),
            accessor: 'address',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('installationDate')),
            accessor: 'installationDate',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('orderAuthorName')),
            accessor: 'orderAuthorName',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('orderNumber')),
            accessor: 'orderNumber',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('orderReceivalDate')),
            accessor: 'orderReceivalDate',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('technicianName')),
            accessor: 'technicianName',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell('VIN'),
            accessor: 'vin',
            Cell: Cell.CutTextCell
        },
        {
            Header: Cell.HeaderTextCell(t('carSupplierCompanyName')),
            accessor: 'carSupplierCompanyName',
            Cell: Cell.CutTextCell
        }
    ];
}

function mapStateToProps(state: any): ConnectedP {
    return {
        reportStore: state.reportStore
    };
}

export default withTranslation('reports')(connect(mapStateToProps)(TerminalInstallationReport) as React.ComponentType<any>);



// WEBPACK FOOTER //
// ./src/components/Raports/ReportsComposites/TerminalInstallationReport.tsx